import React from 'react';

import { Button } from '../Button';
import { buttonColor } from '../Button/ButtonTypes';

import { Error } from './Error';
import styles from './PageError.module.scss';

type PageErrorType = {
  error?: string | Error | React.ReactNode;
};

export const PageError = ({ error }: PageErrorType) => (
  <div className={styles.error}>
    <h2 className="text-danger margin-bottom">{translate('Something went wrong!')}</h2>
    <p className="text-danger margin-bottom">{translate('Try to refresh the page or contact support.')}</p>
    {error && <Error error={error} />}
    <Button
      data-testid="refresh-button"
      className="margin-top"
      onClick={() => window.location.reload()}
      type="button"
      color={buttonColor.primary}
    >
      {translate('Refresh')}
    </Button>
  </div>
);
